// import { createStore, compose, applyMiddleware } from 'redux';
// import thunk from 'redux-thunk';

// import rootReducer from './rootReducer';

// const composeEnhancers = process.env.NODE_ENV !== 'production'
//   && typeof window === 'object'
//   && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//   ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//   : compose;

// const middlewares = [thunk];
// const enhancers = [applyMiddleware(...middlewares)];
// const store = createStore(rootReducer, composeEnhancers(...enhancers));

// export default store;


import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import rootSaga from './sagas';

const nodeEnv = process.env.NODE_ENV;

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    thunk: false,
    serializableCheck: false,
  }).concat(sagaMiddleware),
  devTools: nodeEnv !== 'production',
});

sagaMiddleware.run(rootSaga);

export default store;
